const types = {
  SET_RANDOM_WORD: 'words/set-random-word',
  RESET_WORD: 'words/reset-word',
  SET_PRESSED_KEYS: 'words/set-pressed-keys'
}

export default types
